import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EntradaDetalharComponent } from './entrada-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: EntradaDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class EntradaDetalharRoutingModule { }
